import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Input from "../shared/Input";
import SelectDropdown from "../shared/SelectDropdown";
import { fetchFormData, fetchData } from "../../utils/options";
import topTost from "../../utils/topTost";
import TextArea from "../shared/TextArea";
import { BaseUrl } from "../..";
const ChapterCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [courseOptions, setCourseOptions] = useState([]);
  const [semesterOptions, setSemesterOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);

  const [formData, setFormData] = useState({
    title: "",
    course_id: "",
    semester_id: "",
    subject_id: "",
    description: "",
    status: "1",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!localStorage.getItem("access_token")) navigate("/");
  }, []);

  const handleChange = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));

    // Load dependent dropdowns
    if (key === "course_id") {
      fetchSemesters(value);
      setSemesterOptions([]);
      setSubjectOptions([]);
      setFormData((prev) => ({ ...prev, semester_id: "", subject_id: "" }));
    }

    if (key === "semester_id") {
      fetchSubjects(value);
      setSubjectOptions([]);
      setFormData((prev) => ({ ...prev, subject_id: "" }));
    }
  };

  // Load Courses
  const fetchCourses = async () => {
    try {
      const result = await fetchData("course-dropdown", {}, "POST");
      if (result?.success) {
        setCourseOptions(
          result.data.map((item) => ({
            label: item.title,
            value: item.id,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to load courses:", error);
    }
  };

  // Load Semesters by Course
  const fetchSemesters = async (course_id) => {
    if (!course_id) return;

    const form = new FormData();
    form.append("course_id", course_id);

    try {
      const result = await fetchFormData("semester-dropdown", form, "POST");
      if (result?.success) {
        setSemesterOptions(
          result.data.map((item) => ({
            label: item.title,
            value: item.id,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to load semesters:", error);
    }
  };

  // Load Subjects by Semester
  const fetchSubjects = async (semester_id) => {
    if (!semester_id) return;

    const form = new FormData();
    form.append("semester_id", semester_id);

    try {
      const result = await fetchFormData("subject-dropdown", form, "POST");
      if (result?.success) {
        setSubjectOptions(
          result.data.map((item) => ({
            label: item.title,
            value: item.id,
          }))
        );
      }
    } catch (error) {
      console.error("Failed to load subjects:", error);
    }
  };

  // Fetch Chapter Detail for Edit
  const fetchAllDetails = async (id) => {
    const form = new FormData();
    form.append("id", id);

    try {
      const result = await fetchFormData("chapter-details", form, "POST");

      if (result?.success) {
        const d = result.data;

        setFormData({
          id: d.id,
          title: d.title,
          course_id: d.course_id,
          semester_id: d.semester_id,
          subject_id: d.subject_id,
          description: d.description,
          status: d.status?.toString() || "1",
        });

        // Load dependent dropdown values
        fetchSemesters(d.course_id);
        fetchSubjects(d.semester_id);
      }
    } catch (error) {
      console.log("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchCourses();
    if (id) fetchAllDetails(id);
  }, [id]);

  // Submit Form
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const form = new FormData();
    Object.entries(formData).forEach(([k, v]) => form.append(k, v));

 
  
  try {
      const token = localStorage.getItem("access_token");
      const response = await fetch(
        id ? `${BaseUrl}update-chapter` : `${BaseUrl}create-chapter`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: form,
        }
      );
  
      const data = await response.json();
      const result = data.result;
      if (!result) return;
  
      // Handle validation errors
        if (result?.success==="false" && result?.errors) {
        const firstField = Object.keys(result.errors)[0];
        const errorMsg = result.errors[firstField][0];
        topTost({ title: errorMsg, icon: "error" });
        setIsSubmitting(false);
        return;
      }
      
      // Handle success
      if (
        result?.success === "true" ||
        result?.success === true ||
        result?.code === 200 ||
        result?.code === "200"
      ) {
        topTost({
          title: result.message || (id ? "Updated successfully!" : "Saved successfully!"),
          icon: "success",
        }) 
        setTimeout(()=>{  navigate("/master/chapter-list")},600)
      
     
        setIsSubmitting(false);
        return;
      }
  
      // Handle other errors
      topTost({
        title: result?.message || "Error submitting form",
        icon: "error",
      });
    } catch (error) {
      topTost({ title: "Error submitting form", icon: "error" });
      console.error("Submit error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className="col-lg-12">
        <div className="card stretch stretch-full">
          <hr className="mt-0" />
          <div className="card-body general-info">
            <div className="mb-3 d-flex align-items-center justify-content-between">
              <h5 className="fw-bold mb-0 me-4">
                {id ? "Edit Chapter:" : "Add Chapter:"}
              </h5>
            </div>
            <form onSubmit={handleSubmit} className="p-3 ">
              <div className="mb-3 row align-items-center">
                <label htmlFor="course-select" className="col-lg-2 col-md-2 col-sm-4 fw-semibold">
                  Course Select: <span className="text-danger">*</span>
                </label>
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <SelectDropdown
                    id="course-select"
                    name="course_id"
                    value={formData.course_id}
                    onSelectOption={(option) =>
                      handleChange("course_id", option.value)
                    }
                    options={courseOptions}
                    placeholder="Select an option"
                    icon="fa-opera"
                    required
                  />
                </div>
              </div>
              <div className="mb-3 row align-items-center">
                <label
                  htmlFor="semester-select"
                  className="col-lg-2 col-md-2 col-sm-4 fw-semibold"
                >
                  Semester Select: <span className="text-danger">*</span>
                </label>
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <SelectDropdown
                    id="course-select"
                    name="semester_id"
                    value={formData.semester_id}
                    onSelectOption={(option) =>
                      handleChange("semester_id", option.value)
                    }
                    options={semesterOptions}
                    placeholder="Select an option"
                    icon="feather-file-text"
                    required
                  />
                </div>
              </div>
              <div className="mb-3 row align-items-center">
                <label
                  htmlFor="subject-select"
                  className="col-lg-2 col-md-2 col-sm-4 fw-semibold"
                >
                  Subject Select: <span className="text-danger">*</span>
                </label>
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <SelectDropdown
                    id="course-select"
                    name="subject_id"
                    value={formData.subject_id}
                    onSelectOption={(option) =>
                      handleChange("subject_id", option.value)
                    }
                    options={subjectOptions}
                    placeholder="Select an option"
                   icon="feather-layers"
                    required
                  />
                </div>
              </div>

              <Input
                label="Chapter Name"
                name="title"
                placeholder="Enter Chapter Name"
                value={formData.title}
                onChange={handleChange}
                icon="feather-hash"
                required
              />

              <TextArea
                label="Description"
                placeholder="Enter Description"
                value={formData.description}
                onChange={(e) => handleChange("description", e.target.value)}
                icon="fa-briefcase"
            
              />

              <div className="mt-4 customButton">
                <button
                  type="submit"
                  className="btn btn-lg btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : id ? "Update" : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChapterCreate;


